import styled from 'styled-components';

export const PluginCollection = styled.div`
  margin-top: 27px;
  justify-content: left;
  display: flex;
  flex-direction: row;
  flex: 0 1 auto;
  padding: 0 30px;
  box-sizing: border-box;
`;

export const PluginSelection2ndStepWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
  padding: 0 30px 30px 30px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FullHeightWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow-y: auto;
  padding-left: 40px;
  padding-right: 30px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const CenteringWrapper = styled.div`
  max-width: 1030px;
  margin: 0 auto;
`;
